/*!
 * Image Layout V2 - Swatch Selection
 * Handles color swatch selection and image switching
 */

class ImageLayoutV2 {
  constructor(section) {
    this.section = section;
    this.swatches = section.querySelectorAll('.c-image-layout__swatch');
    this.blocks = section.querySelectorAll('.c-image-layout__block');
    this.selectedColorSpan = section.querySelector('.c-image-layout__selected-color');
    
    this.init();
  }

  init() {
    this.swatches.forEach((swatch, index) => {
      swatch.addEventListener('click', () => this.selectSwatch(index));
    });
  }

  selectSwatch(index) {
    const selectedSwatch = this.swatches[index];
    if (!selectedSwatch) return;

    // Update swatch selection
    this.swatches.forEach(swatch => swatch.classList.remove('is-selected'));
    selectedSwatch.classList.add('is-selected');

    // Update active block
    this.blocks.forEach(block => block.classList.remove('is-active'));
    const targetBlock = this.blocks[index];
    if (targetBlock) {
      targetBlock.classList.add('is-active');
    }

    // Update color name
    const colorName = selectedSwatch.dataset.colorName;
    if (this.selectedColorSpan && colorName) {
      this.selectedColorSpan.textContent = colorName;
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.c-image-layout');
  sections.forEach(section => {
    new ImageLayoutV2(section);
  });
});

// Initialize for theme editor
document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('.c-image-layout');
  if (section) {
    new ImageLayoutV2(section);
  }
});
